<template>
	<div class="personalInfo">
		<van-nav-bar
		  title="个人信息编辑"
		  left-arrow
		  right-text="完成" 
		  @click-left="onClickLeft"
		  @click-right="clickRight"
		/>
	   <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
		<van-cell class="avatar" value="头像">
			<template #right-icon>
				<img :src="msg"  alt="" @error="imgError" @click="inof"  style="border-radius:50% ;"/>
			</template>
		</van-cell>
		<van-field label="姓名" v-model="formData.name" placeholder="请输入姓名" input-align="right" style="font-size: 16px;" />
		<van-field label="昵称" v-model="formData.nickName" placeholder="请输入昵称" input-align="right"  style="font-size: 16px;"/>
		<van-cell class="avatar" value="性别">
			<template #right-icon>
				<van-radio-group v-model="gender" direction="horizontal">
					<van-radio name="GENDER-MAN" checked-color="#FF9500">男</van-radio>
					<van-radio name="GENDER-WOMAN" checked-color="#FF9500">女</van-radio>
					<van-radio name="GENDER-NO" checked-color="#FF9500">未知</van-radio>
				</van-radio-group>
			</template>
		</van-cell>
		<van-cell title="居住地点" is-link value-class="rightal">
			<template>
				<span @click="showPicker = true">{{ proCity }}</span>
			</template>
			<van-popup v-model="showPicker" round position="bottom">
				<van-picker show-toolbar ref="picker" value-key="label" :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
			</van-popup>
		</van-cell>
		<van-cell >
			<template >
				<van-field class="label" v-model="formData.address" placeholder="请输入详细地址"  style="font-size: 16px;" />
			</template>
		</van-cell>
	  </van-pull-refresh>
	</div>
</template>
<script>
	import {
		NavBar,
		Cell,
		RadioGroup,
		Radio,
		Field,
		Picker,
		Popup,
		Dialog,
		PullRefresh  
		// Uploader 	
	} from "vant";
	import {
		city
	} from "@/utlis/areaCity";
	export default {
		name: "personalInfogcs",
		data() {
			return {
				gender: "",
				fileList:[
				 {url:'' }
				],
				msg: "",
				file:[],
				avatar:require("@/assets/iconss.png"),
				formData: {
					accountUid: "",
					name: "",
					nickName: "",
					provinceCode: "",
					provinceName: "",
					cityCode: "",
					cityName: "",
					countyCode: "",
					countyName: "",
					address: ""
				},
				proCity: "请选择省市区",
				columns: city,
				showPicker: false,
				//后台拿到的编码
				provinceCode: "",
				cityCode: "",
				countyCode: "",
			};
		},
		components: {
			"van-nav-bar": NavBar,
			"van-cell": Cell,
			"van-radio-group": RadioGroup,
			"van-radio": Radio,
			"van-field": Field,
			"van-picker": Picker,
			"van-popup": Popup,
			"van-pull-refresh":PullRefresh
			// "van-uploader":Uploader
			
		
		},
		created() {
			 this.queryInformation();
			 this.returtlist=this.$route.params.returtlist;
		},
		mounted() {
			window.uploadAvatar = this.uploadAvatar
		},
		
		methods: {
			//判断404
			imgError(){
				this.msg=this.avatar
			},
			//返回
			onClickLeft() {
				if(this.returtlist==""||this.returtlist==null){
						window.open("app:/#/finish");
					}else{
						 this.$router.back();
					}
			},
			//获取个人信息
			queryInformation() {
				this.$axios({
					url: "/vedm/eAccountApp/engineerInformation/"+localStorage.getItem("accountUid")+"/"+localStorage.getItem("key"),
					method: "get",
					headers: {
						Authorization: localStorage.getItem('token') //token换成从缓存获取
					},
				}).then(res => {
					//console.log(res.data.data,"222333")
					if (res.data.code == 0) {
						this.proCity = res.data.data.account.provinceName + "-" + res.data.data.account.cityName + "-" + res.data.data.account
							.countyName;
						this.formData.name = res.data.data.account.name;
						this.gender = res.data.data.account.gender;
						this.formData.nickName = res.data.data.account.nickName;
						this.formData.address = res.data.data.account.detailAddress
						if(res.data.data.account.avatar==""|| res.data.data.account.avatar==null){
							this.msg=this.avatar
						}else{
							 this.msg=res.data.data.account.avatar;
						}
						
						this.provinceCode = res.data.data.account.provinceCode
						this.cityCode=res.data.data.account.cityCode 
						this.countyCode= res.data.data.account.countyCode
						
					};
					// console.log(this.fileList[0].url,"3rrwer")
					
				}).catch(function (error) {
					    console.log(error)
						this.msg=this.avatar
					    window.app.showReLoginDialog()
				  });
			},
			
		    handleUpload(file){
				this.file.push(file)  // postData是一个数组
				 let url = '/vedm/systemApp/uploadify/abc'
				 let fd = new FormData()
				 var that =this
				fd.append('multipartFile', file.file)
				this.$axios.post(url,fd, {
						headers: {
						    Authorization:  localStorage.getItem('token'),
						   'Content-Type': 'multipart/form-data'
						}
					}).then(function(res) {
						// console.log(res.data.data)
					   that.formData.avatar=res.data.data;
						Dialog({
							message: res.data.msg
						});
					})
					.catch(function(error) {
						console.log(error);
					});
				
				
			},
			
			
			inof(){
			 window.open("app:/#/upload_avatar")	
			},
			 uploadAvatar(str){
				 // if(str==""){
					//  alert(11)
				 // }
			       // console.log(str)
				   this.msg = str
				   Dialog({
				      message: "头像上传成功"
				   });
			       // return "js调用成功"
			    },

			//修改个人信息
			clickRight() {
				Dialog.confirm({
					title: '修改个人信息',
					message: '是否修改个人信息?'
				}).then(() => {
					this.$axios.post('/vedm/accountH5/modifyAccountInfo', {
							"accountId": localStorage.getItem('accountUid'),
							"avatar": this.msg,
							"name": this.formData.name,
							"nickName": this.formData.nickName,
							"cityCode": this.formData.cityCode||this.cityCode,
							"countyCode": this.formData.countyCode ||this.countyCode,
							"detailAddress": this.formData.address ,
							"gender": this.gender,
							"provinceCode": this.formData.provinceCode ||this.provinceCode,
						}, {
							headers: {
								Authorization: localStorage.getItem('token')
							}
						}).then(function(res) {
							Dialog({
								message: res.data.msg
							});
						})
						.catch(function(error) {
							console.log(error);
						});
				}).catch(() => {
					// on cancel
				});

			},
			//获取编码
			onConfirm(value, index) {
				console.log(value, "222")
				this.proCity = value.join("-");
				this.formData.provinceName = value[0];
				this.formData.cityName = value[1];
				this.formData.countyName = value[2];
				this.formData.provinceCode = city[index[0]].value;
				this.formData.cityCode = city[index[0]].children[index[1]].value;
				this.formData.countyCode = city[index[0]].children[index[1]].children[index[2]].value;
				this.showPicker = false;
			},

		}
	};
</script>

<style scoped lang="less">
	.personalInfo {
		width: 100%;
		height: 100%;

		.avatar {
			align-items: center;
			padding: 8px 15px;

			span {
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
			}

			img {
				width: 60px;
			}
		}

		.label {
			padding: 0;
			width: 100%;
		}
	}
</style>
